import create from 'zustand'
import { persist } from 'zustand/middleware'

import type { State } from 'zustand'

export type TKinerjaHarianStore = State & {
  showSurveyDialog: boolean
  setShowSurveyDialog: (show: boolean) => void
  surveyDone: boolean
  markSurveyDone: () => void
}

export const useKinerjaHarianStore = create<TKinerjaHarianStore>(
  persist(
    (set) => ({
      showSurveyDialog: false,
      setShowSurveyDialog: (show) => set({ showSurveyDialog: show }),
      surveyDone: false,
      markSurveyDone: () => set({ surveyDone: true }),
    }),
    {
      name: 'kinerja-harian',
      whitelist: ['surveyDone'],
      getStorage: () => sessionStorage,
    }
  )
)
